// extracted by mini-css-extract-plugin
module.exports = {"container":"LegalDisclaimerBannerRussia_container__PkHnp","inner":"LegalDisclaimerBannerRussia_inner__ww5zC"};